import { render, staticRenderFns } from "./ReservationServiceIcons.vue?vue&type=template&id=e7807bd4&scoped=true&"
import script from "./ReservationServiceIcons.vue?vue&type=script&lang=js&"
export * from "./ReservationServiceIcons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7807bd4",
  null
  
)

export default component.exports